export default {
  actions: {
    SELECT_DATE: 'selectDate'
  },
  mutations: {
    SET_SELECTED_ROOM: 'setSelectedRoom',
    SET_SELECTED_DATE: 'setSelectedDate',
  },
  getters: {
    GET_SELECTED_DATE: 'getSelectedDate',
  }
};



// WEBPACK FOOTER //
// ./src/store/types.js